
import React from 'react';
import { Route } from 'react-router-dom';
import AppLogin from '@/pages/app/AppLogin';
import AppDashboard from '@/pages/app/AppDashboard';
import AppShop from '@/pages/app/AppShop';
import AppShopConcerns from '@/pages/app/AppShopConcerns';
import AppTreatments from '@/pages/app/AppTreatments';
import AppCredits from '@/pages/app/AppCredits';
import AppConcierge from '@/pages/app/AppConcierge';
import AppRewards from '@/pages/app/AppRewards';
import AppBook from '@/pages/app/AppBook';
import TreatmentDetail from '@/pages/app/TreatmentDetail';
import ProtectedRoute from '@/components/ProtectedRoute';

export const AppMobileRoutes = () => (
  <>
    {/* App Login */}
    <Route path="/app/login" element={<AppLogin />} />
    
    {/* App Dashboard - Protected */}
    <Route 
      path="/app/dashboard" 
      element={
        <ProtectedRoute>
          <AppDashboard />
        </ProtectedRoute>
      } 
    />
    
    {/* App Shop - Protected */}
    <Route 
      path="/app/shop" 
      element={
        <ProtectedRoute>
          <AppShop />
        </ProtectedRoute>
      } 
    />
    
    {/* App Shop Concerns - Protected */}
    <Route 
      path="/app/shop/concerns" 
      element={
        <ProtectedRoute>
          <AppShopConcerns />
        </ProtectedRoute>
      } 
    />
    
    {/* App Treatments - Protected */}
    <Route 
      path="/app/treatments" 
      element={
        <ProtectedRoute>
          <AppTreatments />
        </ProtectedRoute>
      } 
    />
    
    {/* Treatment Detail */}
    <Route 
      path="/app/treatments/:slug" 
      element={
        <ProtectedRoute>
          <TreatmentDetail />
        </ProtectedRoute>
      } 
    />
    
    {/* App Credits - Protected */}
    <Route 
      path="/app/credits" 
      element={
        <ProtectedRoute>
          <AppCredits />
        </ProtectedRoute>
      } 
    />
    
    {/* App Rewards - Protected */}
    <Route 
      path="/app/rewards" 
      element={
        <ProtectedRoute>
          <AppRewards />
        </ProtectedRoute>
      } 
    />
    
    {/* App Book - Protected */}
    <Route 
      path="/app/book" 
      element={
        <ProtectedRoute>
          <AppBook />
        </ProtectedRoute>
      } 
    />
    
    {/* App Concierge - Protected */}
    <Route 
      path="/app/concierge" 
      element={
        <ProtectedRoute>
          <AppConcierge />
        </ProtectedRoute>
      } 
    />
  </>
);
